// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".reward[data-v-9fa48c50] {\n  --magic-header: var(--magic-tertiary, #311261);\n  --magic-secondary: var(--magic-tertiary, #311261);\n  --magic-text: var(--magic-tertiary, #311261);\n  color: var(--magic-tertiary, #311261);\n}", ""]);
// Exports
module.exports = exports;
